const colorList = [
    '#f56a00',
    '#7265e6',
    '#ffbf00',
    '#00a2ae',
    '#1f487e',
];

export const generateAvatarColor = (index: number) => (
    index < colorList.length - 1 ? colorList[index + 1] : colorList[0]
);
